import {currencyFormatter} from '@homeaway/hacommons-i18n';

function formatRate(rate, currencyCode, locale) {
    const rateTemplate = rate.length >= 5 ? currencyFormatter.formatNumber({value: rate, currencyCode, locale, useGrouping: false}) : null;
    let newRate;

    if (rate.length >= 7) {
        newRate = Math.round((rate / 1000000) * 10) / 10;
        newRate.toLocaleString(locale.slice(0, 5).replace('_', '-'));
        newRate = rateTemplate.replace(rate, `${newRate}M`);
    } else if (rate.length >= 5) {
        newRate = rate.slice(0, -3);
        newRate = rateTemplate.replace(rate, `${newRate}K`);
    } else {
        newRate = currencyFormatter.formatNumber({value: rate, currencyCode, locale, useGrouping: false});
    }

    return newRate;
}

function localizeRateSummaryCurrency(rentNights, currency, locale) {
    return rentNights && rentNights.map((nightlyPrice) => {
        return formatRate(nightlyPrice, currency, locale);
    });
}

export default localizeRateSummaryCurrency;
export {localizeRateSummaryCurrency, formatRate};
